import QuestionModal from '../../shared/QuestionModal/QuestionModal';
import { useTranslation } from 'react-i18next';

const RemoveWaitingList = () => {
  const { t } = useTranslation();

  return (
    <QuestionModal
      title={t('REMOVE_WAITING_LIST_TITLE')}
      subTitle={''}
      confirmButtonText={t('CANCELLATION_MODAL_CONFIRM_BUTTON')}
      cancelButtonText={t('REMOVE_MODAL_CANCEL_BUTTON')}
    />
  );
};

export default RemoveWaitingList;
